import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store/index'
Vue.use(Router)
function func({ params, query }) {
	return {
		...params,
		...query
	};
}
const router = new Router({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes: [{
			path: '/',
			name: 'home',
			component: Home,
			meta: {
				noHeader: true,
				noFooter: true,
			},
		},
		{
			path: '/detail',
			name: 'detail',
			meta: {
				noFooter: true,
				headerTitle: '装备详情'
			},
			component: () => import('./views/goods/detail.vue')
		},
		{
			path: '/money',
			name: 'money',
			meta: {
				headerTitle: '热血币',
				noFooter: true,
			},
			component: () => import('./views/goods/money.vue')
		},
		{
			path: '/publish',
			name: 'publish',
			meta: {
				headerTitle: '我要出售',
				noFooter: true,
			},
			component: () => import('./views/publish/publish.vue')
		},
		{
			path: '/step2',
			name: 'step2',
			props:func,
			meta: {
				headerTitle: '我要出售',
				noFooter: true,
			},
			component: () => import('./views/publish/step2.vue')
		},
    {
      path: '/suit',
      name: 'suit',
      props:func,
      meta: {
        headerTitle: '我要出售',
        noFooter: true,
      },
      component: () => import('./views/publish/suit.vue')
    },
      {
      path: '/saleAccount',
      name: 'saleAccount',
      props:func,
      meta: {
        headerTitle: '我要出售',
        noFooter: true,
      },
      component: () => import('./views/publish/saleAccount.vue')
    },
		{
			path: '/recharge',
			name: 'recharge',
			props:func,
			meta: {
				headerTitle: '支付',
				noFooter: true,
			},
			component: () => import('./views/publish/recharge.vue')
		},
		{
			path: '/adv',
			name: 'adv',
			props:func,
			meta: {
				headerTitle: '买卖/代练',
				noFooter: true,
			},
			component: () => import('./views/goods/adv.vue')
		},
		{
			path: '/goods',
			name: 'goods',
			props:func,
			meta: {
				headerTitle: '装备',
				noFooter: true,
			},
			component: () => import('./views/goods/goods.vue')
		},
    {
      path: '/viewPage',
      name: 'viewPage',
      props:func,
      meta: {
        headerTitle: '我要购买',
        noFooter: true,
      },
      component: () => import('./views/buy/viewPage.vue')
    },
	]
})

router.beforeEach((to, from, next) => {
	let {
		noFooter,
		headerTitle,
		noHeader
	} = to.meta;
	store.commit('noFooter', noFooter);
	store.commit('noHeader', noHeader);
	store.commit('headerTitle', headerTitle);
	next();
})
export default router
